import React from 'react'
import Actividad from '../../models/Actividad';

import GenerarModales from './GenerarModales';

type Props = {
    actividades: Actividad[]
}

const ModalesActividades = ({actividades}: Props) => {

    return (
        <div id='modalesActividades'>
            {  GenerarModales(actividades)  }
        </div>
    )
}

export default ModalesActividades